<template>
	<div class="modal__content" @click="onDatepickerClose">
    <div v-if="showSubscriptionPlan" class="form-row flex-nowrap flex--align-vertical">
      <div class="flex-grow-1 pr10">
        <label for="dropbox-link">Subscription plan</label>
        <select v-model="planList.selected" class="form-control" :disabled="disabledChangePlan">
          <option v-for="option in planList.options" :value="option.value" :key="option.id">{{option.name}}</option>
        </select>
      </div>
      <div class="flex-none pl10">
        <label for="dropbox-link">select date</label>
        <datepicker ref="projectSettingsDatepicker" class="datepicker--settings h-100" :taskDeadline="projectDeadline" :useInSeconds="true" @updateDeadline="onUpdateDeadline"></datepicker>
      </div>
    </div>
    <button v-if="showSubscriptionPlan" class="btn w-100 mb20" @click.prevent="updatePlan()" :disabled="disabledUpdatePlan">Change Plan</button>

		<div class="form-row">
			<label for="project-name">Project Name</label>
			<input type="text" class="form-control" id="project-name" v-model="projectSettings.name">
		</div>

    <div class="form-row">
      <label for="project-customer-email">Project Owner</label>
      <select name="existing-user" id="project-customer-email" v-model="projectSettings.customerEmail" class="form-control">
        <option :value="null">Select User</option>
        <option v-for="projectUser in projectUsers" :value="projectUser.email"
          :disabled="projectUser.email === projectSettings.customerEmail" :key="projectUser.email">{{projectUser.email}}</option>
      </select>
    </div>

		<div class="form-row">
			<label for="dropbox-link">Source Link</label>
			<input type="text" class="form-control form-control--text-overflow" id="dropbox-link" v-model="projectSettings.dropboxShareLinkToFolder">
		</div>

		<div class="flex flex--justify-center mt20">
			<button class="btn btn--gray-2 mr10" @click="$bus.$emit('modalClose')" type="button">Close</button>
			<button class="btn" @click="onUpdateProperties">Submit</button>
		</div>
	</div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { apiUpdateProject, apiManualSetupPaymentPlan } from '@/api/project.api'
  import { errorMessage } from 'modules/Error'
  import DatePicker from 'components/common/DatePicker'

  export default {
    components: {
      'datepicker': DatePicker
    },
    data () {
      return {
        projectSettings: {
          id: null,
          name: null,
          customerEmail: null,
          dropboxShareLinkToFolder: null
        },
        planList: {
          selected: 'none',
          options: [
            {
              name: 'None',
              value: 'none'
            },
            {
              name: 'Pro',
              value: 'PRO_MONTHLY'
            },
            {
              name: 'Pro Annual',
              value: 'PRO_YEARLY'
            },
            {
              name: 'Pro Legacy',
              value: 'PRO_PLUS'
            },
            {
              name: 'Premium',
              value: 'PREMIUM_MONTHLY'
            },
            {
              name: 'Premium Annual',
              value: 'PREMIUM_YEARLY'
            },
            {
              name: 'Premium Legacy',
              value: 'PREMIUM'
            },
            {
              name: 'Diamond',
              value: 'DIAMOND_MONTHLY'
            },
            {
              name: 'Diamond Annual',
              value: 'DIAMOND_YEARLY'
            }
          ]
        },
        projectDeadline: null
      }
    },

    props: ['args'],

    computed: {
      ...mapGetters({
        projectUsers: 'getPotentialProjectOwners'
      }),

      showSubscriptionPlan () {
        const isAdminPm = this.args.loggedInUserProjectRole === 'admin' || this.args.loggedInUserProjectRole === 'projectManager'
        return isAdminPm && !this.args.activeStripeSubscription
      },

      disabledChangePlan () {
        const { customerPaymentPlanCurrentPeriodEnd } = this.args
        return customerPaymentPlanCurrentPeriodEnd && customerPaymentPlanCurrentPeriodEnd * 1000 < new Date().getTime()
      },

      disabledUpdatePlan () {
        return this.planList.selected === 'none' || this.planList.selected === this.args.customerPaymentPlan || this.projectDeadline === this.args.customerPaymentPlanCurrentPeriodEnd
      }
    },

    created () {
      this.projectSettings = {
        id: this.args.id,
        name: this.args.name,
        customerEmail: this.args.customerEmail,
        dropboxShareLinkToFolder: this.args.dropboxShareLinkToFolder
      }
      if (this.args.customerPaymentPlan) {
        this.planList.selected = this.args.customerPaymentPlan
      }
      this.setProjectDeadline()
    },

    methods: {
      ...mapActions([
        'updateProjectProperties'
      ]),

      setProjectDeadline () {
        const currentDay = Math.round(Date.now() / 1000)
        this.projectDeadline = this.args.customerPaymentPlanCurrentPeriodEnd ? this.args.customerPaymentPlanCurrentPeriodEnd : currentDay
        // TEMP disabled
        // const monthPlusDay = 86400 + 2629743
        // const yearPlusDay = 86400 + 31556926
        // const isYearlyPlan = ['PRO_YEARLY', 'PREMIUM_YEARLY', 'DIAMOND_YEARLY'].includes(this.planList.selected)
        // isYearlyPlan 
        //   ? (this.projectDeadline = currentPeriodEnd + yearPlusDay)
        //   : (this.projectDeadline = currentPeriodEnd + monthPlusDay) 
        // TEMP disabled
        return this.projectDeadline
      },

      async onUpdateProperties () {
        const [err] = await apiUpdateProject(this.projectSettings)
        if (err) return errorMessage(err, 'Unable to update project settings!')
        
        this.updateProjectProperties(this.projectSettings)
        this.$bus.$emit('modalClose')
        return this.$bus.$emit('toastSuccess', 'Project sucessfully updated!')
      },

      async updatePlan () {
        const [err] = await apiManualSetupPaymentPlan(this.args.id, this.planList.selected, this.projectDeadline) 
        if (err) return errorMessage(err, 'Unable to update plan!')
        this.updateProjectProperties({
          id: this.args.id,
          customerPaymentPlan: this.planList.selected,
          customerPaymentPlanCurrentPeriodEnd: this.projectDeadline
        })
        this.$bus.$emit('modalClose')
        return this.$bus.$emit('toastSuccess', 'Project plan sucessfully updated!')
      },

      onUpdateDeadline (deadline) {
        this.projectDeadline = deadline
      },

      onDatepickerClose (e) {
        const isClickOutsideDatepicker = e.target.closest('.datepicker') == null
        const datepickerEl = this.$refs.projectSettingsDatepicker
        if (datepickerEl.showDatepicker && isClickOutsideDatepicker) {
          datepickerEl.onClose()
        } 
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ProjectSettingsModal.vue?a8bfceb4